/**

Coded by www.techhighway.ca

*/

import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import customAlert from "components/MDAlert/customAlert";
import MDBox from "components/MDBox";
// Material Dashboard 2 React example components
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import AgentService from "services/agent-service";
// @mui icons
import {
  Paper,
  useTheme
} from '@mui/material';

import CallButton from 'components/CallButton';
import MDAutocomplete from "components/MDAutocomplete";
import MDButton from "components/MDButton";
import MDCircularProgress from "components/MDCircularProgress";
import MDXEditorComponent from "components/MDEditor";
import MDInput from "components/MDInput";
import MDSwitch from "components/MDSwitch";
import MDTypography from "components/MDTypography";
import { AuthContext, useCache } from "context";
import ClientService from "services/client-service";
import { formatDateTime } from "utility/helpers";
//Constant
const vapiVoiceOptions = {
  'vapi': [
    {
      id: "f99bf0af-e8d3-4cb9-8be0-db77c1fb90ee",
      key: "Hana",
      value: "Carol",
      description: "22 years old female, American, soft, soothing, gentle",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/hana-sample.wav"
    },
    {
      id: "3255b66d-7c7b-4344-9388-802beb60f668",
      key: "Harry",
      value: "Ryan",
      description: "24 year old white male, American, clear, energetic, professional",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/harry-sample.wav"
    },
    {
      id: "79358e5f-db73-4d89-9c87-037bf338bf69",
      key: "Spencer",
      value: "Sierra",
      description: "26 year old, female, American, energetic, quippy, lighthearted, cheeky, amused",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/spencer-sample.wav"
    },
    {
      id: "20c00a43-1f6c-4951-bc2c-26ab41bf8970",
      key: "Neha",
      value: "Priya",
      description: "30 year old, female, Indian, professional, charming",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/neha-sample.wav"
    },
    {
      id: "d4fa1f07-cbe3-4141-b150-95f1a8e0ad54",
      key: "Lily",
      value: "Maya",
      description: "25 years old female, Asian, bright personality, bubbly, cheerful",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/lily-sample.wav"
    },
    {
      id: "3d3b12fe-1641-4c96-b27a-48b85bb66dcb",
      key: "Savannah",
      value: "Caroline",
      description: "25 years old female with an American southern accent",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/savannah-sample.wav"
    },
    {
      id: "b85ab57e-3038-4728-8a4a-2d6cd02757a6",
      key: "Paige",
      value: "Sophia",
      description: "26 year old white female, deeper tone, calming, professional",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/paige-sample.wav"
    },
    {
      id: "a759321b-e350-4d51-aec0-a7e197064fb2",
      key: "Elliot",
      value: "Alex",
      description: "25 years old male, Canadian, soothing, friendly, professional",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/elliot-sample.wav"
    },
    {
      id: "baae7884-b72c-412b-abfd-80dd52f556d9",
      key: "Rohan",
      value: "Aryan",
      description: "24 years old male, Indian American, bright, optimistic, cheerful, energetic",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/rohan-sample.wav"
    },
    {
      id: "f9ac9cff-88bc-4ac4-9f98-f04271c8e3d4",
      key: "Cole",
      value: "Travis",
      description: "22 year old white male, American, deeper tone, calming, professional",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/cole-sample.wav"
    },
  ]
};

const voiceProviderOptions = [
  {
    key: 'vapi',
    value: 'Vapi'
  },
];
const modelProviderOptions = [
  {
    key: 'openai',
    value: 'OpenAI'
  },
  // {
  //   key: 'anyscale',
  //   value: 'Anyscale'
  // },
  // {
  //   key: 'anthropic',
  //   value: 'Anthropic'
  // },
  // {
  //   key: 'cerebras',
  //   value: 'Cerebras'
  // },
  // {
  //   key: 'deepinfra',
  //   value: 'Deep Infra'
  // },
  {
    key: 'deep-seek',
    value: 'DeepSeek'
  },
  // {
  //   key: 'groq',
  //   value: 'Groq'
  // },
  {
    key: 'google',
    value: 'Google'
  },
  // {
  //   key: 'openrouter',
  //   value: 'OpenRouter'
  // },
  // {
  //   key: 'perplexity-ai',
  //   value: 'Perplexity AI'
  // },
  // {
  //   key: 'together-ai',
  //   value: 'Together AI'
  // },
  // {
  //   key: 'xai',
  //   value: 'xAI'
  // },
];
const modelOptions = {
  'openai': [
    {
      key: 'gpt-4.1',
      value: 'GPT 4.1',
      description: '400ms, $0.02'
    },
    {
      key: 'gpt-4.1-mini',
      value: 'GPT 4.1 Mini',
      description: '300ms, $0.01'
    },
    {
      key: 'gpt-4.1-nano',
      value: 'GPT 4.1 Nano',
      description: '250ms, $0.01, Fastest'
    },
    {
      key: 'gpt-4.5-preview',
      value: 'GPT 4.5 Preview',
      description: '450ms, $0.69'
    },
  ],
  'google': [
    {
      key: 'gemini-2.0-flash',
      value: 'Gemini 2.0 Flash',
      description: '1000ms, $0.03'
    },
    {
      key: 'gemini-1.5-flash',
      value: 'Gemini 1.5 Flash',
      description: '1000ms, $0.03'
    },
  ],
  'deep-seek': [
    {
      key: 'deepseek-chat',
      value: 'DeepSeek-V3',
      description: '4000ms, $0.00'
    },
    {
      key: 'deepseek-reasoner',
      value: 'DeepSeek-R1',
      description: '1000ms, $0.01'
    },
  ],
};

const transcriberProviderOptions = [
  {
    key: 'openai',
    value: 'OpenAI'
  },
  {
    key: 'deepgram',
    value: 'Deepgram'
  },
  {
    key: 'google',
    value: 'Google'
  }
];

const transcriberOptions = {
  'deepgram': [
    {
      key: 'nova-3',
      value: 'Nova 3'
    },
    {
      key: 'nova-3-general',
      value: 'Nova 3 General'
    },
    {
      key: 'nova-3-medical',
      value: 'Nova 3 Medical'
    },
    {
      key: 'nova-2-meeting',
      value: 'Nova 2 Meeting'
    },
    {
      key: 'nova-2-finance',
      value: 'Nova 2 Finance'
    },
    {
      key: 'nova-2-automotive',
      value: 'Nova 2 Automative'
    },
    {
      key: 'nova-2-video',
      value: 'Nova 2 Video'
    },
    {
      key: 'nova-2-phonecall',
      value: 'Nova 2 Phone Call'
    },
    {
      key: 'nova-2-conversationalai',
      value: 'Nova 2 Conversational AI'
    },
    {
      key: 'nova-2-drivethru',
      value: 'Nova 2 Drivethru'
    },
    {
      key: 'nova-2-voicemail',
      value: 'Nova 2 Voicemail'
    },
  ],
  'openai': [
    {
      key: 'gpt-4o-transcribe',
      value: 'GPT-4o Transcribe'
    },
    {
      key: 'gpt-4o-mini-transcribe',
      value: 'GPT-4o Mini Transcribe'
    },
  ],
  'google': [
    {
      key: 'gpt-4o-transcribe',
      value: 'GPT-4o Transcribe'
    },
    {
      key: 'gpt-4o-mini-transcribe',
      value: 'GPT-4o Mini Transcribe'
    },
  ]
};

function Form() {
  const theme = useTheme();
  const { action } = useParams();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const navigate = useNavigate();
  const location = useLocation();

  const authContext = useContext(AuthContext);
  const { openAlertSB, closeAlertSB, renderAlertSB } = customAlert();
  const [active, setActive] = useState(1);
  const [headerTitle, setHeaderTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [createdBy, setCreatedBy] = useState("");
  const { cacheItems, setCacheItems, setPageLoader } = useCache();
  const [isData, setIsData] = useState(false);
  const [modelInstructions, setModelInstructions] = useState('');
  const [modelInstructionsLoading, setModelInstructionsLoading] = useState(false);
  const [clientIdDropdown, setClientIdDropdown] = useState([]);
  const [modelDropdown, setModelDropdown] = useState([]);
  const [voiceDropdown, setVoiceDropdown] = useState([]);
  const [transcriberDropdown, setTranscriberDropdown] = useState([]);
  const [isCallInProgress, setIsCallInProgress] = useState(false);
  const [inputs, setInputs] = useState({
    name: "",
    api_id: "",
    greeting_msg: "",
    client_id: "",
    model_provider: "",
    model: "",
    transcriber_provider: "",
    transcriber_model: "",
    voice_provider: "",
    voice_id: "",
    phone: "",
    api_phone_id: "",
    fallback_phone: "",
    created_at: "",
  });

  const [errors, setErrors] = useState({
    nameError: false,
    valueError: false,
  });

  useEffect(() => {
    const getClientData = async() => {
      let response; // Declare response outside the if...else block
      if (cacheItems.hasOwnProperty('clients')) {
        response = cacheItems['clients'];
      } else {
        response = await ClientService.getClients(); // Fetch clients from the API
        setCacheItems(prevCache => ({
            ...prevCache,
            clients: response,
        }));
      }

      if (response) {
        var clientArray = [];
        response?.map((eachCode, index) => {
          clientArray[index] = {
            key: eachCode.id,
            value: eachCode.name,
            disabled: eachCode?.active ? false : true,
          }
        });
        setClientIdDropdown(clientArray);
      }
    }
    getClientData();


    if (action === "add" && id == null) {
      setIsData(true);
      return;
    }

    const showAgent = async () => {
      try {
        setModelInstructionsLoading(true);
        const data = await AgentService.showAgent(id);
        if (action === "add") {
          data.api_id = '';
          data.phone = '';
          data.api_phone_id = '';
          data.fallback_phone = '';
        }
        setModelDropdown(modelOptions[data?.model_provider]);
        setVoiceDropdown(vapiVoiceOptions[data?.voice_provider]);
        setTranscriberDropdown(data?.transcriber_provider ? transcriberOptions[data?.transcriber_provider] : []);
        setHeaderTitle(data?.name);
        setInputs(data);
        setCreatedBy(
          `${data?.user?.first_name + (data?.user?.middle_name ? ` ${data?.user?.middle_name}` : "")} ${
            data?.user?.last_name
          } (${formatDateTime(data?.created_at)})`
        );
        setActive(data?.active);
        setModelInstructions(data?.model_instructions);
        setModelInstructionsLoading(false);
        setPageLoader(false);
        setIsData(true);
      } catch (res) {
        setModelInstructionsLoading(false);
        setPageLoader(false);
        setIsData(true);
        if (res.hasOwnProperty("message")) {
          const state = { color: "error", icon: "warning", msg: res.message, title: "Agent" };
          navigate("/manage-agents", { state });
        } else {
          const state = {
            color: "error",
            icon: "warning",
            msg: res.errors[0].detail,
            title: "Agent",
          };
          navigate("/manage-agents", { state });
        }
      }
    };
    showAgent();
  }, []);

  const changeHandler = (e) => {
    setLoading(false);
    // setInputs({
    //   ...inputs,
    //   [e.target.name]: e.target.value,
    // });
    const updatedInputs = {
      ...inputs,
      [e.target.name]: e.target.value,
    };
    switch (e.target.name) {
      case 'model_provider':
        setModelDropdown(modelOptions[e.target.value]);
        updatedInputs['model'] = '';
        break;
      case 'transcriber_provider':
        setTranscriberDropdown(transcriberOptions[e.target.value]);
        updatedInputs['transcriber_model'] = '';
        break;
      case 'voice_provider':
        setVoiceDropdown(vapiVoiceOptions[e.target.value]);
        updatedInputs['voice_id'] = '';
        break;
    }
    setInputs(updatedInputs);
  };

  const submitHandler = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (inputs.name.trim().length < 1) {
      setErrors({ ...errors, nameError: true });
      return;
    }

    const newAgent = { 
      name: inputs.name, 
      api_id: inputs.api_id,
      greeting_msg: inputs.greeting_msg,
      client_id: inputs.client_id,
      model_provider: inputs.model_provider,
      model: inputs.model,
      transcriber_provider: inputs.transcriber_provider,
      transcriber_model: inputs.transcriber_model,
      voice_provider: inputs.voice_provider,
      voice_id: inputs.voice_id,
      phone: inputs.phone,
      api_phone_id: inputs.api_phone_id,
      fallback_phone: inputs.fallback_phone,
      model_instructions: modelInstructions,
      active: active ? 1 : 0 
    };

    if (action === "add") {
      try {
        setPageLoader(true);
        const response = await AgentService.addAgent(newAgent);
        setLoading(false);
        if (response) {
          const state = {
            color: "success",
            icon: "check",
            msg: "Agent Added Successfully!",
            title: "Agent",
          };
          navigate("/manage-agents", { state });
        }
        setPageLoader(false);
      } catch (res) {
        setPageLoader(false);
        if (res.hasOwnProperty("message")) {
          openAlertSB({ color: "error", icon: "warning", msg: res.message, title: "Agent" });
          setTimeout(function () {
            closeAlertSB();
          }, 4000);
        } else {
          openAlertSB({
            color: "error",
            icon: "warning",
            msg: res.errors[0].detail,
            title: "Agent",
          });
          setTimeout(function () {
            closeAlertSB();
          }, 4000);
        }
        setLoading(false);
      }
    } else {
      try {
        setPageLoader(true);
        const response = await AgentService.updateAgent(id, newAgent);
        setLoading(false);
        if (response) {
          openAlertSB({
            color: "success",
            icon: "check",
            msg: "Agent Updated Successfully!",
            title: "Agent",
          });
          setTimeout(function () {
            closeAlertSB();
          }, 4000);
        }
        setPageLoader(false);
      } catch (res) {
        setPageLoader(false);
        if (res.hasOwnProperty("message")) {
          openAlertSB({ color: "error", icon: "warning", msg: res.message, title: "Agent" });
          setTimeout(function () {
            closeAlertSB();
          }, 4000);
        } else {
          openAlertSB({
            color: "error",
            icon: "warning",
            msg: res.errors[0].detail,
            title: "Agent",
          });
          setTimeout(function () {
            closeAlertSB();
          }, 4000);
        }
        setLoading(false);
      }
    }

    return () => {
      setInputs({
        name: "",
        value: "",
      });

      setErrors({
        nameError: false,
        valueError: false,
      });
    };
  };

  const handleEditorChange = (value) => {
    setModelInstructions(value);
  };

  return (
    <>
      <DashboardLayout
        breadcrumbsTitle={action === "add" ? "Add Agent" : `Edit Agent : ${headerTitle}`}
        isNotFound={inputs?.id && inputs?.id > 0 || action === 'add' ? false : true}
        isData={isData}
      >
        <MDBox py={3}>
          <MDBox component="form" role="form" method="POST" onSubmit={submitHandler}>
            <Grid container>
              <Grid item xs={12} md={3} px={1}>
                <Paper elevation={3} sx={{ p: 3, mb: 4, borderLeft: `6px solid ${theme.palette.info.main}` }}>
                  <Grid container>
                    <Grid item xs={12} md={12} pb={2}>
                      <MDTypography variant="h5" gutterBottom>
                        Basic Settings
                      </MDTypography>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={12} md={12}>
                      <MDBox mb={2}>
                        <MDInput
                          type="text"
                          label="Name"
                          fullWidth
                          value={inputs.name}
                          name="name"
                          inputProps={{ maxLength: 50 }}
                          onChange={changeHandler}
                          error={errors.nameError}
                          required
                        />
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <MDBox mb={2}>
                        <MDAutocomplete
                          label="Client"
                          name="client_id"
                          options={clientIdDropdown}
                          value={inputs.client_id}
                          onChange={changeHandler}
                          required
                        />
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <MDBox mb={2}>
                        <MDInput
                          type="text"
                          label="API Id"
                          fullWidth
                          value={inputs.api_id}
                          name="api_id"
                          inputProps={{ maxLength: 32 }}
                          onChange={changeHandler}
                          error={errors.apiError}
                          readOnly
                        />
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <MDBox mb={2}>
                        <MDAutocomplete
                          label="Model Provider"
                          name="model_provider"
                          options={modelProviderOptions}
                          value={inputs.model_provider}
                          onChange={changeHandler}
                          required
                        />
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <MDBox mb={2}>
                        <MDAutocomplete
                          label="Model"
                          name="model"
                          options={modelDropdown}
                          value={inputs.model}
                          onChange={changeHandler}
                          required
                        />
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <MDBox mb={2}>
                        <MDAutocomplete
                          label="Transcriber Provider"
                          name="transcriber_provider"
                          options={transcriberProviderOptions}
                          value={inputs.transcriber_provider}
                          onChange={changeHandler}
                        />
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <MDBox mb={2}>
                        <MDAutocomplete
                          label="Transcriber Model"
                          name="transcriber_model"
                          options={transcriberDropdown}
                          value={inputs.transcriber_model}
                          onChange={changeHandler}
                        />
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <MDBox mb={2}>
                        <MDAutocomplete
                          label="Voice Provider"
                          name="voice_provider"
                          options={voiceProviderOptions}
                          value={inputs.voice_provider}
                          onChange={changeHandler}
                          required
                        />
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <MDBox mb={2}>
                        <MDAutocomplete
                          label="Voice Id"
                          name="voice_id"
                          options={voiceDropdown}
                          value={inputs.voice_id}
                          onChange={changeHandler}
                          required
                        />
                      </MDBox>
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <MDBox mb={2}>
                        <MDInput
                          type="text"
                          label="Phone"
                          fullWidth
                          name="phone"
                          value={inputs.phone}
                          error={errors.phoneError}
                          onChange={changeHandler}
                          helperText={errors.phoneError ? "Phone should be 10 digits" : ""}
                        />
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <MDBox mb={2}>
                        <MDInput
                          type="text"
                          label="API Phone Id"
                          fullWidth
                          value={inputs.api_phone_id}
                          name="api_phone_id"
                          inputProps={{ maxLength: 32 }}
                          onChange={changeHandler}
                          error={errors.apiError}
                          readOnly
                        />
                      </MDBox>
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <MDBox mb={2}>
                        <MDInput
                          type="text"
                          label="Fallback Phone"
                          fullWidth
                          name="fallback_phone"
                          value={inputs.fallback_phone}
                          error={errors.phoneError}
                          onChange={changeHandler}
                          helperText={errors.phoneError ? "Fallback Phone should be 10 digits" : ""}
                        />
                      </MDBox>
                    </Grid>
                    <Grid item md={12} xs={12} sx={{ textAlign: 'right' }}>
                      <MDBox>
                        <MDSwitch checked={active ? true : false} onChange={() => setActive(prev => !prev)} label="Active" inputProps={{ 'aria-label': 'controlled' }} color="info" />
                      </MDBox>
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <MDBox mb={0} mt={7}>
                        {createdBy ? (<MDTypography display="block" fontStyle="italic" fontSize="0.75rem !important" color="text.secondary" variant="body2" sx={{ whiteSpace: 'nowsrap' }}>
                          Created by : {createdBy}
                        </MDTypography>) : '-'}
                      </MDBox>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              <Grid item container xs={12} md={9} px={1}>
                <Paper elevation={3} sx={{ p: 3, mb: 4, borderLeft: `6px solid ${theme.palette.success.main}` }}>
                  
                  <Grid item container>
                    <Grid item xs={12} md={12} pb={3}>
                      <MDTypography variant="h5">
                        Agent Instructions
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} md={12} pb={1}>
                      <MDBox mb={2}>
                        <MDInput
                          fullWidth
                          rows={3}
                          type="text"
                          label="Greeting Message"
                          name="greeting_msg"
                          value={inputs.greeting_msg}
                          inputProps={{ maxLength: '250' }}
                          onChange={changeHandler}
                          required
                        />
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={12} pb={2}>
                      {modelInstructionsLoading ? (
                        <MDBox
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          marginTop={15}
                        >
                          <MDCircularProgress
                            size={80}
                            color="success"
                          />
                        </MDBox>
                      ) : (<MDXEditorComponent
                          label="Model Instructions"
                          value={modelInstructions}
                          name="model_instruction"
                          onChange={handleEditorChange}
                          placeholder="Model Instructions"
                      />)}
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
            <Grid container mt={2}>
              <Grid item md={10} xs={1}></Grid>
              <Grid item md={1} xs={3}>
                <MDBox mr={2}>
                  <MDButton component={Link} to="/manage-agents" variant="gradient" color="primary" fullWidth>
                    Back
                  </MDButton>
                </MDBox>
              </Grid>
              <Grid item md={1} xs={3}>
                <MDBox mr={3}>
                  <MDButton variant="gradient" color="info" fullWidth type="submit" disabled={loading}>
                      {loading ? (<MDCircularProgress
                        size={24}
                        sx={{
                          position: "absolute",
                        }}
                      />
                    ) : action === "add" ? (
                      "Save"
                    ) : (
                      "Update"
                    )}
                  </MDButton>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
        
        {/* Action buttons should go inside this MDBox */}
        {inputs.api_id ? (
          <MDBox position="absolute" right="10px" mt={-4.5}>
            <CallButton agent_api_id={inputs.api_id} />
          </MDBox>
        ) : ''}
      </DashboardLayout>
      {renderAlertSB}
    </>
  );
}

export default Form;
